import { createFileRoute, Navigate } from '@tanstack/react-router';
import { pageTitle } from '@/utils/pageTitle';
import { CustomerDepositTable } from '@/components/Pages/Ledgers/CustomerDepositTable';
import { Box } from '@mui/joy';
import { useAuth } from '@/contexts/AuthContext';

export const Route = createFileRoute('/_protected/ledgers/customer-deposits/')({
  component: CustomerDepositsPage,
  head: () => pageTitle('Depósitos'),
});

function CustomerDepositsPage() {
  const { hasClaim, isLoading } = useAuth();
  const canRead = hasClaim('BALANCES_READ');

  if (!isLoading && !canRead) {
    return <Navigate to='/' />;
  }

  return (
    <Box>
      <CustomerDepositTable
        emptyMessage='No hay depósitos de clientes registrados'
        errorTitle='Error al cargar los depósitos de clientes'
      />
    </Box>
  );
}
